import { useQuery } from "@apollo/client";
import { LIST_STORE } from "../apollo/queries";

const useBrands = ({ pageStart, limit }) => {
  const { loading, error, data } = useQuery(LIST_STORE, {
    variables: {
      input: {
        pageStart,
        limit,
        name: null,
        is_active: null,
      },
    },
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("Error While Getting Brands", error);
  }

  console.log("datadatadata", data);

  return {
    values: {
      allStoreByAdmin: data?.allStoreByAdmin || [], // Assuming the API returns an items array
      total: data?.allStoreByAdmin?.total || 0, // Assuming the API returns a total count
      loading,
    },
  };
};

export default useBrands;
